import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_MINUS: GlameraIconDefinition = {
  name: 'minus',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-minus-mark" d="M5 12h14"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-minus-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './minus.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class MinusIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_MINUS;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
